<template>
  <v-dialog v-model="dialog.show" persistent max-width="600">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor" class="pt-2">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row dense>
            <v-col cols="12">
              <SelectEmpresa
                ref="selectEmpresas"
                :multiple="true"
                :selectedEmpresas="selecionados"
                :empresasSelecionadas="empresas_vinculadas"
                @onChanged="empresas = $event"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Colaborador from "@/services/colaborador";

export default {
  name: "DialogEmpresas",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  data() {
    return {
      dialog: {
        title: "Vincular Colaborador a Empresas",
        show: false
      },
      empresas: null,
      colaborador: null,
      selecionados: null,
      empresas_vinculadas: []
    };
  },

  methods: {
    show(show = false, item) {
      this.empresas_vinculadas = item.empresas;
      this.colaborador = item;

      this.selecionados = item.empresas;

      this.dialog.show = show;
    },

    async save() {
      try {
        await new Colaborador().updateColaboradorEmpresa(
          this.colaborador.id,
          this.empresas
        );

        this.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    close() {
      this.empresas = null;
      this.colaborador = null;
      this.selecionados = null;
      this.dialog.show = false;
    }
  }
};
</script>
